import AreasPage from './AreasPage';

export default AreasPage;
